import { type DemoDT, DEMO_SCHEMA } from '@/models/demo-dt';
// import { type AAFarmer, FARMER_SCHEMA } from '@/models/aa-farmer';
import { type OutgrowerMonitoringQuestionnaire, OUTGROWER_MONITORING_SCHEMA } from '@/models/outgrower-monitoring';
import { type OutgrowerFarmer, OUTGROWER_FARMER_SCHEMA } from '@/models/outgrower-farmer';
import Dexie, { type EntityTable } from "dexie";

export class ShambaODKDB extends Dexie {
    demos!: EntityTable<DemoDT, "phone">;
    // farmers!: EntityTable<AAFarmer, "phone_number">;
    outgrower_monitoring_questionnaires!: EntityTable<OutgrowerMonitoringQuestionnaire, "id">;
    outgrower_farmers!: EntityTable<OutgrowerFarmer, "phone_number">;

    constructor() {
        super("shamba-odk");
        this.version(3).stores({
            demos: DEMO_SCHEMA,
            // farmers: FARMER_SCHEMA,
            outgrower_monitoring_questionnaires: OUTGROWER_MONITORING_SCHEMA,
            outgrower_farmers: OUTGROWER_FARMER_SCHEMA,
        })
        this.open();
    }

    clearSyncedDemos() {
        return this.transaction("rw", this.demos, () => {
            this.demos.where({ status: "synced" }).delete();
        })
    }

    // clearSyncedFarmers() {
    //     return this.transaction("rw", this.farmers, () => {
    //         this.farmers.where({ status: "synced" }).delete();
    //     })
    // }

    clearSyncedOutgrowerMonitoringQuestionnaires() {
        return this.transaction("rw", this.outgrower_monitoring_questionnaires, () => {
            this.outgrower_monitoring_questionnaires.where({ status: "synced" }).delete();
        })
    }

    clearSyncedOutgrowerFarmers() {
        return this.transaction("rw", this.outgrower_farmers, () => {
            this.outgrower_farmers.where({ status: "synced" }).delete();
        })
    }
}

export const db = new ShambaODKDB();

db.on("ready", () => {
    console.log("ShambaODKDB ready");
})